const getters = {
  session: state => state.user.session,
  hasSignIn: state => state.user.hasSignIn,
  account: state => state.user.account,
  accountImg: state => state.user.accountImg,
  nickname: state => state.user.nickname,
  roleClass: state => state.user.roleClass,
  lang: state => state.user.lang,
  comActive: state => state.user.comActive,
  allreadStatus: state => state.user.allreadStatus,
  routerName: state => state.router.routerName
}

export default getters



// WEBPACK FOOTER //
// ./src/stores/getter.js